export const SET_ACTIVE_FILTERS_FROM_SEARCH_QUERY =
  "consulting/set-active-filters-from-search-query";
export const SET_ACTIVE_FILTERS = "consulting/set-active-filters";
export const TOGGLE_FILTER = "consulting/toggle-filter";
export const PRESELECT_FILTER = "consulting/preselect-filter";
export const POPULATE_FILTERS = "consulting/populate-filters";
export const POPULATE_PRODUCTS = "consulting/populate-products";
export const POPULATE_NEXT_PRODUCT_PAGE = "consulting/populate-next-product-page";
export const ACTIVE_FILTER_NUM = "consulting/active-filters-num";
export const ACTIVATE_PRESELECTED_FILTER = "consulting/activate-preselected-filter";
export const ACTIVATE_ALL_PRESELECTED_FILTERS = "consulting/activate-all-preselected-filters";
export const CLEAR_ALL_FILTERS = "consulting/clear-all-filters";
export const CLEAR_ALL_PRESELECTED_FILTERS = "consulting/clear-all-preselected-filters";
export const DESELECT_FILTERS = "consulting/deselect-filters";
export const RESET = "consulting/reset";
export const CLEAR_NON_TOPIC_FILTERS = "consulting/clear-non-topic-filters";
